import { useQuery } from 'react-query';
import { fetchPlayFactoryVideo, PlayFactoryResponse, MediaUrls, Expiration, isPlayFactoryAvailable } from '../utils/playFactoryApi';
import { SimpleAsset } from '../utils/types';
import { useMemo } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import duration from 'dayjs/plugin/duration';
dayjs.extend(duration);

const DEFAULT_CDN = 'CLOUDFRONT'
export const PLAY_FACTORY_PROVIDER = 'PlayFactory'

const convertToExpiration = (now: Dayjs, dateString?: string): Expiration | undefined => {
    const expirationDate = dateString ? dayjs(dateString) : undefined

    if (!expirationDate) {
        return undefined
    }
    return {
        date: expirationDate,
        expired: expirationDate.isBefore(now)
    }

}
interface PlayFactoryData {
    mediaData: MediaUrls;
    isLoading: boolean;
    isError: boolean;
}

export const usePlayFactoryData = (drmHlsSource?: SimpleAsset): PlayFactoryData => {
    const { data: playFactoryData, isLoading, isError } = useQuery<PlayFactoryResponse>(
        ['playFactory', drmHlsSource?.providerVariantId],
        () => fetchPlayFactoryVideo(drmHlsSource!.providerVariantId!),
        {
            enabled: isPlayFactoryAvailable() && !!drmHlsSource?.providerVariantId && drmHlsSource?.drmProvider.toLocaleLowerCase() === PLAY_FACTORY_PROVIDER.toLocaleLowerCase(),
            cacheTime: dayjs.duration(5, 'minutes').asMilliseconds(),
            retry: 2
        }
    );

    const mediaData = useMemo<MediaUrls>(() => {
        if (playFactoryData) {
            const endpoint = playFactoryData.deliveryEndpoints.find(endpoint =>
                endpoint.cdn === DEFAULT_CDN
            );
            const now = dayjs();


            const mediaExpiration = convertToExpiration(now, playFactoryData.expirations.deliveryEndpoints)
            const licenseExpiration = convertToExpiration(now, playFactoryData.expirations.licenseAcquisitionUrl)

            return {
                videoUrl: endpoint?.url ?? playFactoryData.deliveryEndpoints[0]?.url,
                licenseUrl: playFactoryData.licenseAcquisitionUrl,
                expirations: {
                    media: mediaExpiration,
                    license: licenseExpiration
                }
            }

        }
        return {
            videoUrl: drmHlsSource?.url,
            licenseUrl: undefined,
            expirations: {
                media: undefined,
                license: undefined
            }
        };
    }, [playFactoryData, drmHlsSource]);

    return {
        mediaData,
        isLoading,
        isError
    };
};
